import React from "react";
import about from "../../images/Assets/about.png";
import tick from "../../images/Assets/tick.png";

export default function AboutUs() {
  return (
    <div className="md:px-6 xl:px-10 px-28 pt-16 pb-14">
      <div className="max-w-7xl mx-auto">
        <div className="flex md:flex-col flex-row items-center justify-center gap-20">
          <div className="w-full">
            <div className="bg-[#F8F6FA] text-[14px] text-[#5B2ED9] font-gilroySemibold uppercase w-fit py-0.5 px-2.5 rounded-full">
              About us
            </div>

            <div className="md:text-[22px] text-[40px] text-[#0E062A] font-gilroySemibold md:leading-tight leading-[50px] text-start mt-2">
              Unleash the Power of AI <br className="xl:hidden flex" /> with Komodo AI
            </div>

            <div className="md:text-[16px] text-[18px] text-[#544D68] font-gilroyRegular text-start mt-6">
              At Komodo AI, we partner with startups to build cutting-edge AI{" "}
              <br className="xl:hidden flex" /> solutions, empowering businesses with the technology of the{" "}
              <br className="xl:hidden flex" /> future, today.
            </div>

            <div className="md:text-[16px] text-[18px] text-[#544D68] font-gilroyRegular text-start mt-3">
              <span className="font-gilroyBold">Our promise?</span> An AI solution that's not only functional
              but perfectly <br className="xl:hidden flex" /> aligned with your business goals and the needs
              of your market.
            </div>

            <hr className="text-[#544D68] my-6" />

            <div className="flex items-center md:gap-2 gap-3.5">
              <img src={tick} alt="tick" className="w-[28px] h-[28px]" />

              <div className="md:text-[14px] text-[16px] text-[#544D68] font-gilroyRegular">
                <span className="md:text-[16px] text-[18px] text-[#0E062A] font-gilroySemibold">
                  Secured:
                </span>{" "}
                Deployed in your premise
              </div>
            </div>

            <div className="flex items-center md:gap-2 gap-3.5 mt-5">
              <img src={tick} alt="tick" className="w-[28px] h-[28px]" />

              <div className="md:text-[14px] text-[16px] text-[#544D68] font-gilroyRegular">
                <span className="md:text-[16px] text-[18px] text-[#0E062A] font-gilroySemibold">
                  Precised:
                </span>{" "}
                Zero hallucinations
              </div>
            </div>

            <div className="flex items-center md:gap-2 gap-3.5 mt-5">
              <img src={tick} alt="tick" className="w-[28px] h-[28px]" />

              <div className="md:text-[14px] text-[16px] text-[#544D68] font-gilroyRegular">
                <span className="md:text-[16px] text-[18px] text-[#0E062A] font-gilroySemibold">
                  Customizable:
                </span>{" "}
                Customize to your domain / data
              </div>
            </div>
          </div>

          <div className="w-full flex items-center justify-center">
            <img src={about} alt="about" />
          </div>
        </div>
      </div>
    </div>
  );
}
